import { render } from "./profilePost.vue?vue&type=template&id=776b6952"
import script from "./profilePost.vue?vue&type=script&lang=js"
export * from "./profilePost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__